import { storage } from '@/config'

export function getAccount() {
  if (storage) {
    if ('localStorage' === storage) {
      return JSON.parse(localStorage.getItem('civilization_account'))
    } else if ('sessionStorage' === storage) {
      return JSON.parse(sessionStorage.getItem('civilization_account'))
    } else {
      return JSON.parse(localStorage.getItem('civilization_account'))
    }
  } else {
    return JSON.parse(localStorage.getItem('civilization_account'))
  }
}

export function setAccount(obj) {
  if (storage) {
    let info = JSON.stringify(obj)
    if ('localStorage' === storage) {
      return localStorage.setItem('civilization_account', info)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.setItem('civilization_account', info)
    } else {
      return localStorage.setItem('civilization_account', info)
    }
  } else {
    let info = JSON.stringify(obj)
    return localStorage.setItem('civilization_account', info)
  }
}
